export default {
    orgLogo: (orgName) => `Logo de ${orgName}`,
    appLogo: (appName) => `Logo de ${appName}`,
    page: (numPages) => `Page${numPages === 1 ? '' : 's'}`,
    closePreview: `Fermer l'aperçu`,
    saveFinish: `Enregistrer et terminer`,
    saveFinishLater: `Enregistrer et terminer plus tard`,
    saveFinishLaterDesc: `Vous pouvez enregistrer votre progression sur ce formulaire et le remplir plus tard. Un lien vous permettant de continuer vous sera envoyé par courriel.`,
    pinRequired: `NIP requis`,
    pinRequiredDesc: `Un NIP est requis pour visualiser ce formulaire.`,
    alreadySubmitted: `Ce formulaire a déjà été soumis`,
    submitPin: `Soumettre le NIP`,
    goButton: `GO`,
    hint: `Indice`,
    dontKnowPin: `Vous ne connaissez pas le NIP?`,
    formSaved: `Le formulaire a été enregistré`,
    mayCloseWindow: `Vous pouvez maintenant fermer cette fenêtre.`,
    requiredAttachments: `Pièces jointes obligatoires`,
    requiredAttachmentsDesc: `Avant de pouvoir envoyer le formulaire, vous devez fournir les pièces jointes obligatoires suivantes`,
    backToForm: `Retour au formulaire`,
    submitTo: (orgName) => `Soumettre à ${orgName}`,
    submitForm: `Soumettre le formulaire`,
    submitFormDesc: `Pour soumettre ce formulaire, nous avons besoin de quelques informations vous concernant.`,
    willBeEmailedConfirmation: `Une confirmation vous sera envoyée à l'adresse courriel fournie.`,
    firstName: `Prénom`,
    lastName: `Nom de famille`,
    emailAddress: `Adresse courriel`,
    next: `Suivant`,
    saveProceedPayment: `Enregistrer et procéder au paiement`,
    savingForm: `Enregistrement du formulaire`,
    formSaved: `Formulaire enregistré`,
    completeRequiredFields: `Veuillez remplir les champs obligatoires`,
    submitFormAgree: (healthcareMode) => `
        Une fois que vous aurez soumis ce formulaire, vous ne pourrez plus le modifier ni le soumettre à nouveau.
        ${healthcareMode ? `` : ` Vous pourrez imprimer ou enregistrer le formulaire rempli après l'avoir soumis.`}
        <br><br>
        En soumettant ce formulaire, vous acceptez les 
        <a href='https://kb.paperworkforms.com/terms-and-policies/terms-of-service' target='_blank'>conditions d'utilisation</a>.
        <br><br>
    `,
    submittingForm: `Soumission du formulaire`,
    attemptsRemaining: (remaining) => {
        let num = remaining || 'Aucune';
        return `${num} tentative${num <= 1 ? '' : 's'} restante${num <= 1 ? '' : 's'}`;
    },
    tryAgainMinutes: (mins) => `vous pouvez réessayer dans ${mins} minute${mins <= 1 ? '' : 's'}`,
    contactForPin: (orgName, phone) => `Veuillez contacter ${orgName}${phone ? `au ${phone}` : ``} pour récupérer le NIP de ce formulaire.`,
    unableToSaveForm: `Impossible de enregistrer le formulaire`,
    formUnsavedChanges: `Ce formulaire contient des modifications non enregistrées qui seront perdues si vous quittez sans enregistrer.`,
    formNumOfNum: (cur, total) => `Formulaire <span>${cur}</span> de <span>${total}</span>`,
    pageNumOfNum: (cur, total) => `Page <span>${cur}</span> de <span>${total}</span>`,
    previousPage: `Page précédente`,
    nextPage: `Page suivante`,
    increaseZoom: `Augmenter le zoom`,
    decreaseZoom: `Diminuer le zoom`,
    print: `Imprimer`,
    downloadPdf: `Télécharger le PDF`,
    openAnotherDevice: `Ouvrir le formulaire sur un autre appareil`,
    loadingPackage: `Chargement du paquet de formulaires`,
    redirectingTo: (domain) => `Rediriger vers ${domain}`,
    paymentProcessingError: `Erreur de traitement du paiement`,
    paymentProcessingErrorDesc: (msg) => `
        Une erreur s'est produite lors du traitement de votre paiement:<br>
        ${msg}<br><br>
        Vous pouvez soit essayer de payer à nouveau, soit quitter et revenir plus tard. 
        Les informations que vous avez saisies dans ce formulaire ont été enregistrées et ne seront pas perdues si vous fermez cette page.
    `,
    paymentCancelled: `Paiement annulé`,
    processingPayment: `Traitement du paiement`,
    paymentTookTooLong: `Le paiement a pris trop de temps pour être effectué`,
    paymentVerifyError: (orgName) => `
        Malheureusement, nous ne sommes pas en mesure de vérifier que le paiement a été traité avec succès. 
        Vous pouvez soit essayer de payer à nouveau, soit contacter ${orgName} et vous renseigner sur le paiement de ce formulaire.<br><br>
        Les informations que vous avez saisies dans ce formulaire ont été enregistrées et ne seront pas perdues si vous fermez cette page.
    `,
    paymentSuccess: `Paiement effectué avec succès`,
    signatures: `Signatures`,
    nextSignature: `Signature suivante`,
    formBackgroundImage: `Image de fond du formulaire`,
    paymentCompleted: `Paiement effectué`,
    paymentRequired: `Paiement requis`,
    total: `TOTAL`,
    viewReceipt: `Voir le reçu`,
    paymentRedirectError: `
        Une erreur s'est produite et votre paiement n'a pas pu être effectué. 
        Le processeur de paiement qui vous a redirigé ici est peut-être mal configuré. 
        Veuillez contacter l'organisation qui vous a envoyé le formulaire pour signaler ce problème et demander des instructions sur la manière de procéder.
    `,
    submissionSuccessful: `Soumission réussie`,
    receiveCopyEmail: `Vous recevrez une copie de votre soumission par courriel`,
    printConfirmation: `Imprimer le reçu<br>de confirmation`,
    printSubmittedForms: `Enregistrer/Imprimer<br>les formulaires soumis`,
    confirmation: `Confirmation`,
    submittedBy: `Soumis par`,
    submittedTo: `Soumis à`,
    submittedForms: `Formulaires soumis`,
    attachments: `Pièces jointes`,
    paymentSummary: `Résumé du paiement`,
    poweredBy: (appName) => `Propulsé par ${appName}`,
    dateAtTime: `à`,
    formSavedEmailLink: `Ce formulaire a été enregistré. Ce lien vous a été envoyé par courriel et vous permettra de continuer la modification à tout moment.`,
    mayCloseOrContinue: `Vous pouvez maintenant fermer cette fenêtre ou continuer à éditer le formulaire.`,
    printCompletedForm: `Imprimer le formulaire rempli`,
    downloadCompletedForm: `Télécharger le formulaire rempli`,
    formDoesNotExist: `Le formulaire demandé n'existe pas`,
    creatingPdf: `Création de PDF`,
    pdfNotFound: `Le PDF demandé n'a pas pu être trouvé.`,
    pdfError: `Erreur PDF`,
    fieldIsRequired: `Ce champ est obligatoire`,
    signatureIsRequired: `Cette signature est obligatoire`,
    mustBeChecked: `Ce champ doit être coché`,
    optionMustBeSelected: `L'une de ces options doit être sélectionnée`,
    fieldMustBeSelected: `L'un de ces champs doit être sélectionné`,
    voidSignature: (num) => `Annuler ${num > 1 ? 'les' : 'la'} signature${num > 1 ? 's' : ''}`,
    voidSignatureDesc: (num, signers) => {
        const signersLen = signers.length;
        const lastSigner = signersLen > 1 ? ` et ${signers.pop()}` : '';
        signers = signers.join(', ') + lastSigner;
        return `
            La modification de ce champ annulera ${num > 1 ? 'les' : 'la'} signature${num > 1 ? 's' : ''} de ${signers} sur ce formulaire.
            <br><br>
            Êtes-vous sûr de vouloir continuer?
        `;
    },
    voidSignatureEdit: (num) => `Annuler ${num > 1 ? 'les' : 'la'} signature${num > 1 ? 's' : ''} et modifier`,
    fieldIncorrectFormatting: (num) => num > 1
        ? `${num} champs sont mal formatés.`
        : `Ce champ est mal formaté.`,
    invalidValue: `Valeur invalide`,
    cancel: `Annuler`,
    saveFormError: (orgName) => `
        Nous sommes désolés, une erreur s'est produite lors de l'enregistrement des données du formulaire. 
        Pour être sûr de ne rien perdre de votre travail, veuillez imprimer le formulaire en cliquant sur le bouton d'impression ci-dessus. 
        Contactez ${orgName} et demandez-leur comment ils souhaitent que vous soumettiez le formulaire. 
        Nous nous excusons pour ce problème et nous ferons en sorte qu'il ne se reproduise plus à l'avenir.
    `,
    pdfTabBlocked: (isPrint) => `
        Un bloqueur de fenêtres pop-up a empêché ${isPrint ? `l'impression` : `le téléchargement`}.
        Veuillez autoriser les fenêtres pop-up de ce site et réessayer.
    `,
    failRedirectToPayment: `Désolé, nous ne pouvons pas vous rediriger vers le processeur de paiement pour le moment.`,
    requiredAttachment: `Pièce jointe obligatoire`,
    optionalAttachment: `Pièce jointe facultative`,
    helpUploading: `Aide au téléchargement de fichiers`,
    attachmentFormatsAccepted: `Formats acceptés : PDF, images, documents Word, feuilles de calcul`,
    noAttachedFiles: `Pas de fichiers joints`,
    helpUploadingDesc: `
        Les fichiers des formats suivants sont acceptés : PDF, JPEG, PNG, GIF, DOC, DOCX, XLS, XLSX, ODT, ODS.
        <br><br> 
        Les fichiers ne doivent pas dépasser 25 Mo chacun. 
        <br><br> 
        Si vous rencontrez des difficultés pour télécharger un fichier, vérifiez que le format est accepté et que sa taille est inférieure à 25 Mo. 
        Essayez ensuite de télécharger à nouveau le fichier.
    `,
    viewInitials: `Voir les initiales`,
    viewSignature: `Voir la signature`,
    addYourInitials: `Ajouter vos initiales`,
    addYourSignature: `Ajouter votre signature`,
    change: `Modifier`,
    drawSignature: (initials) => `Dessinez ${initials ? 'vos initiales' : 'votre signature'} dans la case ci-dessous:`,
    signature: `Signature`,
    signaturePlainText: (initials) => `Dessiner ${initials ? 'mes initiales' : 'ma signature'} en texte simple`,
    signatureCursive: (initials) => `Dessiner ${initials ? 'mes initiales' : 'ma signature'} en cursive`,
    eraseSignature: (initials) => `Effacer ${initials ? 'les initiales' : 'la signature'}`,
    iAgreeToThe: `J'accepte les`,
    eSignatureTerms: `conditions générales de la signature électronique`,
    adoptSign: (initials) => `Adopter et ${initials ? 'parapher' : 'signer'}`,
    ok: `OK`,
    eSigningMustAgree: `Avant de procéder à la signature électronique, vous devez accepter les conditions générales de la signature électronique.`,
    eSignatureCheckbox: (orgName) => `
        En cochant cette case, vous acceptez d'être lié par la  
        <a href="/terms?org=${encodeURIComponent(orgName)}" target="_blank">déclaration de divulgation et de consentement relative à la signature électronique</a> et, par la présente, vous adoptez la marque dessinée, écrite ou dactylographiée dans le champ de signature comme votre signature, comme si vous aviez apposé votre signature à l'encre sur ce document.
    `,
    enterFirstName: `Veuillez saisir votre prénom`,
    enterLastName: `Veuillez saisir votre nom de famille`,
    contactSearch: `Recherche de contact`,
    clear: `Effacer`,
    typeToSearch: `Tapez pour rechercher`,
    searching: `Recherche`,
    noContactsFound: `Aucun contact trouvé`,
    searchContacts: `Rechercher des contacts`,
    noEmailAddress: `Pas d'adresse courriel`,
    noEmailAddressDesc: `
        Ce contact n'a pas d'adresse courriel dans le fichier.
        Vous ne pourrez pas lui envoyer ce formulaire par voie électronique tant qu'une adresse courriel n'aura pas été ajoutée.
    `,
    chooseDate: `Cliquez pour choisir une date`,
    chooseOption: `Choisir une option`,
    filledWhenSigned: `Ce champ est rempli automatiquement lors de la signature du formulaire`,
    signaturePresent: `La signature est présente`,
    signatureNotPresent: `La signature n'est pas présente`,
    initials: `Initiales`,
    clickToInitial: `Cliquez pour parapher`,
    clickToSign: `Cliquez ici pour ajouter votre signature`,
    requiredBeforeSigning: (num) => `${num} champs obligatoires doivent être remplis avant la signature.`,
    uploadFiles: (multiple) => `Télécharger ${multiple ? 'des fichiers' : 'un fichier'}`,
    orDragAndDrop: `ou glisser-déposer`,
    removeFile: `Supprimer le fichier`,
    uploadAnother: (multiple) => `${multiple ? 'Télécharger' : 'Choisir'} un autre fichier`,
    maximumFileSizeAccepted: `Taille maximale des fichiers acceptée`,
    uploading: `Téléchargement`,
    dragDropOneFile: `Veuillez ne glisser/déposer qu'un seul fichier`,
    unsupportedFileType: (fileName) => `Le fichier "${fileName}" a un type de fichier non pris en charge.`,
    fileTooLarge: (fileName, maxFileSize) => `Le fichier "${fileName}" est trop volumineux (la taille maximale est de ${maxFileSize} Mo)`,
    formLink: `Lien vers le formulaire`,
    copy: `Copier`,
    copied: `Copié`,

    /**
     * dateformat localizations (undefined uses english default)
     */
    dayNames: [`Dim`, `Lun`, `Mar`, `Mer`, `Jeu`, `Ven`, `Sam`, `Dimanche`, `Lundi`, `Mardi`, `Mercredi`, `Jeudi`, `Vendredi`, `Samedi`],
    monthNames: [`Janv`, `Févr`, `Mars`, `Avr`, `Mai`, `Juin`, `Juil`, `Août`, `Sept`, `Oct`, `Nov`, `Déc`, `Janvier`, `Février`, `Mars`, `Avril`, `Mai`, `Juin`, `Juillet`, `Août`, `Septembre`, `Octobre`, `Novembre`, `Décembre`],
    timeNames: undefined,

    /**
     * API Errors
     */
    // General errors
    'GEN-RNF': `Route ou ressource non trouvée`,
    'GEN-SVE': `Erreur de serveur`,
    'GEN-RTO': `Échec de la connexion au serveur (demande expirée)`,
    'GEN-PDN': `Permission refusée`,
    'GEN-GAE': `Trop de tentatives`,
    'GEN-DNE': `La ressource n'existe pas`,
    'GEN-IDS': `La date sélectionnée n'est pas valide`,
    'GEN-MRI': `Il manque des informations à la demande`,
    'GEN-PNF': `Partenaire introuvable`,
    'GEN-IRC': `Code région non valide`,

    // Filler errors
    'FILL-FAC': `Ce formulaire a déjà été rempli par une autre personne et ne peut plus être enregistré`,
    'FILL-IAT': `L'accès à ce formulaire a été révoqué par l'expéditeur et il ne peut plus être rempli`,
    'FILL-IVF': `Un ou plusieurs champs ne sont pas correctement formatés`,
    'FILL-MRI': `La demande a échoué parce que certaines informations requises étaient manquantes`,
    'FILL-BAM': `Ce type de fichier n'est pas pris en charge pour les pièces jointes`,
    'FILL-ELF': `Un ou plusieurs champs ont été modifiés, ils sont verrouillés et ne peuvent pas être enregistrés`,
    'FILL-RNC': `Ce formulaire a été modifié par l'expéditeur et ne peut plus être enregistré`,
    'FILL-PIN': `Un NIP doit être fourni pour accéder à ce formulaire`,
    'FILL-IPP': `NIP erroné`,
    'FILL-PAE': `Trop de tentatives de saisie du NIP`,

    // Package errors
    'PKG-MRI': `La demande a échoué parce que certaines informations requises étaient manquantes`,
    'PKG-PNE': `Le formulaire demandé n'existe pas`,
    'PKG-UNP': `Vous n'avez plus accès à ce formulaire`,
    'PKG-ISP': `La demande de recherche contient des paramètres non valides`,
    'PKG-ERR': `Une erreur interne s'est produite lors de la récupération de ce formulaire`,
    'PKG-PGF': `Une erreur interne s'est produite lors de la création de ce PDF`,
    'PKG-PND': `Le paquet n'est plus un projet et ne peut pas être supprimé`,

    // Payment errors
    'PAY-NPP': `Les paiements n'ont pas encore été configurés pour cette organisation`,
    'PAY-PIC': `Les paiements ont été mal configurés pour cette organisation`,
    'PAY-PNE': `Le paiement n'existe plus`,
    'PAY-PCE': `Une erreur s'est produite lors du calcul du total du paiement. Veuillez vous assurer que tous les champs sont correctement remplis et réessayez.`,
};